export var ButtonModifiers;
(function (ButtonModifiers) {
    ButtonModifiers["normal"] = "";
    ButtonModifiers["place"] = "place";
    ButtonModifiers["disabled"] = "disabled";
    ButtonModifiers["accepted"] = "accept";
    ButtonModifiers["suspended"] = "suspended";
    ButtonModifiers["clear"] = "clear";
    ButtonModifiers["stake"] = "stake";
    ButtonModifiers["changedStake"] = "changedStakeBtn";
})(ButtonModifiers || (ButtonModifiers = {}));
;
//# sourceMappingURL=ButtonModifiers.js.map